import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=8fad3fc6&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=js&"
export * from "./Mask.vue?vue&type=script&lang=js&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=8fad3fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fad3fc6",
  null
  
)

export default component.exports